/* Product accordion anchor-like positioning.
 * Native <details> remains fully functional without JavaScript; this only improves
 * the viewport position after a customer opens a collapsible product row. */

(() => {
  if (window.orhavnProductAccordionScrollBound) return;
  window.orhavnProductAccordionScrollBound = true;

  const TOP_GAP = 8;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const summary = event.target.closest('details[data-product-accordion-scroll] > summary');
    if (!summary) return;

    const details = summary.parentElement;
    if (details.open) return;

    /* The native click toggles <details> after this listener. Two frames let the
       expanded content finish layout before the final document position is read. */
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!details.isConnected || !details.open) return;

        const stickyHeader = document.querySelector('sticky-header');
        const stickyType = stickyHeader?.dataset.stickyType;
        const headerIsAlwaysVisible = stickyType === 'always' || stickyType === 'reduce-logo-size';
        const headerHeight = headerIsAlwaysVisible
          ? document.querySelector('.section-header')?.getBoundingClientRect().height || 0
          : 0;
        const targetTop = window.scrollY + details.getBoundingClientRect().top - headerHeight - TOP_GAP;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        window.scrollTo({ top: Math.max(0, targetTop), behavior });
      });
    });
  });
})();
